// extracted by mini-css-extract-plugin
export default {"contentWrapper":"ContentText_contentWrapper__eOeWw","content":"ContentText_content__NAvvN","brightFont":"ContentText_brightFont__PNfm-"};